import { Base } from './_base';
import { merge_by_template } from '@shared/helpers/collections';

export class ListFrontend extends Base {
  constructor(item) {
    super(item);

    this.data = merge_by_template(this.data, {
      params: {
        list_id: null
      },
      options: {
        yes: null,
        no: null
      }
    });
  }
}
